import { SetURLSearchParams } from 'react-router-dom';

interface RevenueShareFilterHandlerProps {
  setSearchParams: SetURLSearchParams;
  filterParams: Record<string, string>;
}

export const getRevenueShareFilterHandler = ({
  setSearchParams,
  filterParams,
}: RevenueShareFilterHandlerProps): {
  handleApplyFilters: () => void;
  handleOnClickFilterReset: () => void;
} => {
  const handleOnClickFilterReset = (): void => {
    setSearchParams({
      start_yearmon: ['2024-01'],
      end_yearmon: ['2024-12'],
      group_by: ['season'],
    });
  };

  const handleApplyFilters = (): void => {
    setSearchParams(prev => ({
      ...prev,
      ...filterParams,
    }));
  };
  return { handleApplyFilters, handleOnClickFilterReset };
};
